import React, {useState, Fragment} from 'react'
import {Slider} from "xsolla-uikit";
import styled, { css, ThemeProvider } from "styled-components";

export function SbSizer(props) {

  const {
    min=0,
    max=30,
    key,
    type = 'buttons',
    size='sm',
    // focused= {(!index) ?  true : false}
    input,
  } = {...props}


  const act = (action) => {
    let increment = (max - min)/5;
    let ret = input['value'] + (increment * action);
    ret = ret < min ? min : ret > max ? max : ret;


    ret = Math.round(ret * 100) / 100

    if (max < 20 ) ret = Math.round(ret)

    return ret;
  }


  return (
<Fragment>


<CSSb0>
  <CSSb
    onClick={()=> input['onChange'](act(-1))}
  >remove_circle</CSSb>
  <CSSb
    onClick={()=> input['onChange'](act(1))}
  >add_circle</CSSb>
<div style={{flexGrow:1}}>
  <Slider {...props}/>
</div>
</CSSb0>




</Fragment>
  )
}



export const CSSb = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 24px;
  font-family: 'Materialicons';
  cursor: pointer;
  &:hover {
    color: #1477F4;
  }
`;

export const CSSb0 = styled.div`
  justify-content: center;
  align-items: center;
  /* display: inline-flex; */
  /* display: flex; */
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr 8fr;
  grid-column-gap: 8px;
`;
